<div
  ui-popover
  [uiTitle]="titleTemplate"
  [uiContent]="contentTemplate"
  [uiOverlayClassName]="'mention-popover'"
  [uiVisible]="isVisible()"
  (uiVisibleChange)="changePopoverState($event)"
  [uiOrigin]="sourceMentionEl"
  [uiPlacement]="'bottom'"></div>

<ng-template #titleTemplate>
  <div class="header">
    <div class="avatar">
      <img src="{{ user.picture ? user.picture : '/dist/img/icons/unknown.svg' }}" alt="Unknown" />
    </div>

    <div class="details">
      <span class="name">{{ user.firstName + " " + user.lastName }}</span>
      <span class="info">{{ user.email }}</span>
    </div>

    <ui-icon uiTheme="outline" uiType="close-big" (click)="close()"></ui-icon>
  </div>
</ng-template>

<ng-template #contentTemplate>
  <div class="content">
    <button gh-button class="small secondary" (click)="openProfile()">{{ profileBtnLabel }}</button>
  </div>
</ng-template>
